import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { Box, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { F0DatePicker, F0Select } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import AddEmployeesNoticeBox from 'modules/shift_management/components/ShiftManagement/AddEmployeesNoticeBox'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ImportEmployeesToSMSchemaType } from 'modules/shift_management/lib/forms/ImportEmployeesToSM/schema'
import numberOfRestDaysOptions from 'modules/time_planning/lib/numberOfRestDaysOptions'

interface Props {
  form: UseFormReturn<ImportEmployeesToSMSchemaType>
  selectableEmployeeIds: string[]
}

const FormContent = ({ form, selectableEmployeeIds }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasRestDays = hasFeatureFlag('shift_management_rest_day')
  const { getValues, setValue } = form
  const employeeSelection = getValues('employeeSelection')
  const [open, toggle] = useState<boolean>(false)
  const onChangeNumberOfRestDaysCheckbox = (value: boolean) => {
    if (!value) {
      setValue('numberOfRestDaysInCents', null)
    }

    toggle(value)
  }

  return (
    <Box gap="s16">
      <EmployeeSelectorV2
        label={i18n.t('common.employees')}
        onChange={(value) => setValue('employeeSelection', value)}
        multiple
        forcedFilters={{ employeeIds: selectableEmployeeIds }}
        value={employeeSelection?.type === 'manual' ? employeeSelection.ids : undefined}
      />
      <AddEmployeesNoticeBox />
      <F0DatePicker
        label={i18n.t('shift_management.import_employees.effective_date')}
        onChange={(value) => {
          if (!value?.value) return
          setValue('effectiveAt', value.value.from)
        }}
        size="md"
        value={{
          granularity: 'day',
          value: {
            from: getValues('effectiveAt'),
            to: getValues('effectiveAt'),
          },
        }}
      />
      {hasRestDays && (
        <>
          <TogglerCheckbox
            label={i18n.t(
              'time_planning.planning_versions.forms.apply_number_of_rest_days_checkbox'
            )}
            value={open}
            onChange={onChangeNumberOfRestDaysCheckbox}
          />
          {open && (
            <F0Select
              value={getValues('numberOfRestDaysInCents')}
              onChange={(value: number | null) => setValue('numberOfRestDaysInCents', value)}
              label={i18n.t('time_planning.planning_versions.forms.number_of_rest_days')}
              options={numberOfRestDaysOptions()}
            />
          )}
        </>
      )}
    </Box>
  )
}

export { FormContent }
